import React from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import type { State } from "@/signomatic/store/reducers"

interface SignTypeLinkOwnProps {
  type: string
  children?: React.ReactNode | string
}

interface SignTypeLinkStateProps {
  signs: SignType[]
}

type SignTypeLinkProps = SignTypeLinkStateProps & SignTypeLinkOwnProps

const SignTypeLink: React.FC<SignTypeLinkProps> = ({ signs, type, children }) => {
  const sign = signs.find(item => item.key === type)

  if (!sign) {
    return null
  }

  return <Link to={sign.signomatic_path}>{children}</Link>
}

export default connect(({ signs }: State) => ({
  signs,
}))(SignTypeLink)
